<template>
  <div class="box">
    <div class="left-box">
      <div class="head-box">
        <h4>租户计费</h4>
      </div>
      <div class="left-content c-p-10">
        <el-upload
          class="avatar-uploader"
          style="margin: 10px auto 20px;"
          action
          :show-file-list="false"
          :auto-upload="false"
          :on-change="getFileToBase64"
        >
          <img v-if="profile.avatar && profile.avatar.length > 50" :src="profile.avatar" />
          <img v-else src="../assets/user.png" />
        </el-upload>
        <el-form
          :model="profile"
          :rules="rules"
          ref="profile"
          label-width="70px"
          label-position="left"
          hide-required-asterisk
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="profile.name" suffix-icon="el-icon-user" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="profile.phone"
              suffix-icon="el-icon-mobile-phone"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="profile.email" suffix-icon="el-icon-message" disabled></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="profile.address"
              suffix-icon="el-icon-map-location"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
        <!-- <div slot="footer" style="display:flex">
          <el-button
            style="flex:1"
            @click="
              billingFormData = {};
              openDetail = true;
              billingFormData.tenantId = tenantId;
            "
            >购买新套餐</el-button
          >
        </div>-->
      </div>
    </div>
    <div class="right-box c-p-t-10">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="产品与服务" name="productsServices">
          <div style="width:100%">
            <el-table ref="table" :data="fpi.newData" highlight-current-row>
              <!-- <el-table-column fixed="right" width="150" label="操作">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="doUpgrade(scope.row)"
                    size="mini"
                    >升级</el-button
                  >
                </template>
              </el-table-column>-->
              <el-table-column
                prop="parentTransactionId"
                label="关联账单信息id"
                width="130px"
              ></el-table-column>
              <el-table-column
                prop="vipSuit"
                label="购买套餐"
                :formatter="formatterSuit"
              ></el-table-column>
              <el-table-column prop="origionPrice" label="原价格" width="100px"></el-table-column>
              <el-table-column prop="price" label="价格" width="100px"></el-table-column>
              <el-table-column prop="state" label="产品状态" width="100px"></el-table-column>
              <el-table-column prop="payState" label="支付状态" width="100px"></el-table-column>
              <el-table-column prop="payDate" label="支付时间" width="140px"></el-table-column>
              <el-table-column
                prop="vipStartDate"
                label="会员创建日期"
                width="140px"
              ></el-table-column>
              <el-table-column
                prop="vipEndDate"
                label="会员创建日期"
                width="140px"
              ></el-table-column>
              <el-table-column
                prop="vipMaxUserCout"
                label="会员最大用户数"
                width="130px"
              ></el-table-column>
              <el-table-column
                prop="vipMaxWorkflowCount"
                label="会员最大流程数"
                width="130px"
              ></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="交易记录" name="record">
          <div style="width:100%">
            <el-table :data="fpi.data">
              <el-table-column
                prop="parentTransactionId"
                label="关联账单信息id"
                width="130px"
              ></el-table-column>
              <el-table-column
                prop="vipSuit"
                label="购买套餐"
                :formatter="formatterSuit"
              ></el-table-column>
              <el-table-column prop="origionPrice" label="原价格" width="100px"></el-table-column>
              <el-table-column prop="price" label="价格"></el-table-column>
              <el-table-column prop="state" label="产品状态"></el-table-column>
              <el-table-column prop="payState" label="支付状态" width="100px"></el-table-column>
              <el-table-column prop="payDate" label="支付时间" width="100px"></el-table-column>
              <el-table-column
                prop="vipStartDate"
                label="会员创建日期"
                width="140px"
                sortable
              ></el-table-column>
              <el-table-column
                prop="vipEndDate"
                label="会员创建日期"
                sortable
                width="140px"
              ></el-table-column>
              <el-table-column
                prop="vipMaxUserCout"
                label="会员最大用户数"
                width="130px"
              ></el-table-column>
              <el-table-column
                prop="vipMaxWorkflowCount"
                label="会员最大流程数"
                width="130px"
              ></el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              @size-change="pageSizeChange"
              @current-change="pageChange"
              :current-page="fpi.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="fpi.rows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="fpi.total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="套餐详情" :visible.sync="openDetail">
        <el-form
          :model="billingFormData"
          :rules="rules"
          ref="billingFormData"
          label-width="120px"
          label-position="left"
          hide-required-asterisk
        >
          <el-form-item label="选择套餐">
            <el-select v-model="billingFormData.vipSuit">
              <el-option
                v-for="item in options.vipSuit"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-show="item.value == '0'"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付状态">
            <el-input v-model="billingFormData.payState"></el-input>
          </el-form-item>
          <el-form-item label="原价钱">
            <el-input v-model="billingFormData.price"></el-input>
          </el-form-item>
          <el-form-item label="价钱">
            <el-input v-model="billingFormData.origionPrice"></el-input>
          </el-form-item>
          <el-form-item label="选择开始日期">
            <el-date-picker
              v-model="billingFormData.vipStartDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="选择截至日期">
            <el-date-picker
              v-model="billingFormData.vipEndDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="会员截止日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="会员最大用户数">
            <el-input v-model="billingFormData.vipMaxUserCout"></el-input>
          </el-form-item>
          <el-form-item label="会员最大流程数">
            <el-input v-model="billingFormData.vipMaxWorkflowCount"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="doSave">确 定</el-button>
          <el-button @click="doInit">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'preferences',
  data() {
    return {
      profile: {}, //个人资料表单
      rules: this.$util.rules,
      activeName: 'first',
      formData: {}, //修改密码表单,
      activeTab: 'productsServices',
      fpi: {},
      options: {
        codecfg_vipState: { codeId: 'VIPSTATE' },
        codecfg_vipType: { codeId: 'VIPTYPE' },
        codecfg_vipSuit: { codeId: 'VIPSUIT' }
      },
      billingFormData: {}, //租户计费表单
      openDetail: false,
      isNew: false,
      tenantId: ''
    };
  },
  //引用父页面方法
  inject: ['logout', 'getProfile'],
  mounted() {
    window.$this = this;
    this.getProfileInfo();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'account',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || [];
        for (var item of res.data) {
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
        }
        this.osg.codeoption(() => {
          this.getData();
        });
      },
      { noload: true }
    );
  },
  methods: {
    getData() {
      var params = {
        page: 1,
        rows: 10,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/tenantTransaction/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
        this.fpi.newData = [this.fpi.data[0]];
        this.tenantId = this.fpi.newData && this.fpi.newData[0] && this.fpi.newData[0].tenantId;
      });
    },
    doInit() {
      this.formData = {};
      if (this.$refs.formData) this.$refs.formData.resetFields();
      if (this.$refs.billingFormData) this.$refs.billingFormData.resetFields();
      this.openDetail = false;
    },
    //获取当前租户信息
    getProfileInfo() {
      var tenantID = JSON.parse(sessionStorage['entity']).entityID;
      this.osg.ajax(`tenant/find/${tenantID}.do`, {}, res => {
        this.profile = res.entity;
      });
    },
    //上传头像图片文件转base64
    getFileToBase64(file, fileList) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式!', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB!', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.profile.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    //修改个人资料
    profileSave() {
      if (this.osg.validate('profile')) {
        this.osg.ajax('tenant/upsert.do', this.profile, res => {
          this.osg.toast('个人资料保存成功！');
          this.getProfileInfo();
          this.getProfile();
        });
      }
    },
    //修改密码
    passwordSave() {
      if (this.osg.validate('formData')) {
        this.osg.ajax('account/changePasswd_pc.do', this.formData, res => {
          this.doInit();
          this.osg.alert('密码修改成功，请重新登录！', () => {
            this.logout();
          });
        });
      }
    },
    doSave() {
      this.billingFormData._id = '';
      delete this.billingFormData.createTime;
      delete this.billingFormData.updateTime;

      let that = this;
      this.osg.ajax('basic/tenantTransaction/upsert.do', that.billingFormData, res => {
        this.getData();
        this.doInit();
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doUpgrade(row) {
      this.openDetail = true;
      this.billingFormData = row;
      this.billingFormData.parentTransactionId = row._id;
    },
    formatterState(row, column, cellValue, index) {
      return this.osg.codelabel('vipState', cellValue);
    },
    formatterType(row, column, cellValue, index) {
      return this.osg.codelabel('vipType', cellValue);
    },
    formatterSuit(row, column, cellValue, index) {
      return this.osg.codelabel('vipSuit', cellValue);
    },
    handleClick() {}
  }
};
</script>
